<template>
  <div>
    <v-row
      class="justify-center  align-center my-3"
    >
      <v-img
        src="../assets/logo.jpg"
        max-height="250"
        max-width="250"
      >
      </v-img>
    </v-row>
    <v-row
      class="justify-center  align-center my-3"
    >
      <h1>Piano採点アプリ</h1>
    </v-row>
    <v-row
      class="justify-center  align-center mt-8"
    >
      <div>こんにちは、{{ getUser }}さん</div>
    </v-row>
    <v-container class="mt-12">
      <v-row
        class="justify-center  align-center my-8"
      >
        <v-btn
          width="200"
          rounded
          color="deep-purple"
          dark
        >
          使い方
        </v-btn>
      </v-row>
      <v-row
        class="justify-center  align-center my-8"
      >
        <v-btn
          width="200"
          rounded
          color="deep-purple"
          dark
          to="/assessment"
        >
          採点する
        </v-btn>
      </v-row>
      <v-row
        class="justify-center  align-center my-8"
      >
        <v-btn
          width="200"
          rounded
          color="deep-purple"
          dark
          to="/login"
        >
          <span v-if="!this.$store.state.user">ログイン/登録</span>
          <span v-if="this.$store.state.user">ログアウト</span>
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "HomeTitle",
  computed: {
    getUser(){
      if (this.$store.state.user){
        return this.$store.state.user.username
      }
      else{
        return "gest"
      }
    }
  }
}
</script>